<template>
  <div id="team-leverage-summary-containier" class="border-padding">
  <main>
    <div class="row">
      <div class="col-md-1"  v-if="season_dropdown.data != undefined">
        <label class="typo__label">Season</label>
        <multiselect
          v-model="season_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          placeholder=""
          :options="season_dropdown.data"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>

      <div class="col-md-2"  v-if="leverage_dropdown.data != undefined">
        <label class="typo__label">{{ leverage_dropdown.label }}</label> <a href='https://darrylblackport.com/posts/2020-12-22-pbpstats-leverage/' target="_blank">(Details)</a>
        <multiselect
          v-model="leverage_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :options="leverage_dropdown.data"
          :searchable="false"
          :show-labels="false"
          placeholder=""
          :preselect-first="false"
          :allow-empty="true"
          :close-on-select="false"
          :multiple="true">
          <template slot="tag" slot-scope="props"><span class="custom__tag"><span>{{ props.option.text }}</span><span class="custom__remove" @click="props.remove(props.option)">❌</span></span></template>
        </multiselect>
      </div>
    </div>

    <div class="border-padding">
      <button class="" v-on:click="changeStats()">Get Stats</button>
    </div>

    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>

    <div v-if="table_data.length > 0">
        <vue-good-table
            :columns="table_columns"
            :rows="table_data"
            :pagination-options="{ enabled: false}"
            :line-numbers="true"
            :searchOptions="{ enabled: false}"
            :sort-options="{ enabled: true, initialSortBy: {field: 'off_poss', type: 'desc'}}"
            styleClass="vgt-table bordered striped">
        </vue-good-table>
    </div>
  </main>
  </div>
</template>

<script>
import axios from 'axios'
import GetDropdownOptions from './mixins/get_dropdown'
import Multiselect from 'vue-multiselect'
import { rateStats } from './mixins/rate_stats'
import { tableUtils } from './mixins/table_utils'
import { season, leverage } from './mixins/dropdowns'

export default {
  name: 'TeamLeverageSummary',
  components: {
    Multiselect
  },
  mixins: [rateStats, tableUtils, GetDropdownOptions, season, leverage],
  data () {
    return {
      loading: false,
      season_dropdown: {},
      season_selected: undefined,
      leverage_dropdown: {},
      leverage_selected: [],
      table_data: [],
      table_columns: [
        {'field': 'team', 'label': 'Team'},
        {'field': 'off_poss', 'label': 'Off Poss'},
        {'field': 'def_poss', 'label': 'Def Poss'},
        {'field': 'off_rtg', 'label': 'OffRtg', 'type': 'number'},
        {'field': 'def_rtg', 'label': 'DefRtg', 'type': 'number'},
        {'field': 'net_rtg', 'label': 'NetRtg', 'type': 'number'},
        {'field': 'seconds_per_poss_off', 'label': 'Off Seconds Per Poss', 'type': 'number'},
        {'field': 'seconds_per_poss_def', 'label': 'Def Seconds Per Poss', 'type': 'number'},
        {'field': 'efg', 'label': 'eFG%', 'type': 'percentage'},
        {'field': 'opp_efg', 'label': 'Opp eFG%', 'type': 'percentage'},
        {'field': 'fg2_pct', 'label': 'FG2%', 'type': 'percentage'},
        {'field': 'opp_fg2_pct', 'label': 'Opp FG2%', 'type': 'percentage'},
        {'field': 'fg3_pct', 'label': 'FG3%', 'type': 'percentage'},
        {'field': 'opp_fg3_pct', 'label': 'Opp FG3%', 'type': 'percentage'},
        {'field': 'oreb_pct', 'label': 'OReb%', 'type': 'percentage'},
        {'field': 'dreb_pct', 'label': 'DReb%', 'type': 'percentage'},
        {'field': 'to_per_100', 'label': 'Turnovers Per 100', 'type': 'number'},
        {'field': 'opp_to_per_100', 'label': 'Opp Turnovers Per 100', 'type': 'number'},
        {'field': 'fta_per_fga', 'label': 'FTA per FGA', 'type': 'number'},
        {'field': 'opp_fta_per_fga', 'label': 'Opp FTA per FGA', 'type': 'number'}
      ],
      show_error_message: false,
      use_text_filters: true,
      api_endpoint: 'get-team-leverage-summary/'
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    '$route': 'updateData',
    '$parent.league': 'changeLeague'
  },
  methods: {
    changeLeague () {
      this.season_dropdown = {}
      this.season_selected = undefined
      this.season_type_selected = undefined
      this.table_data = []
      this.$router.push({name: 'team_leverage_summary', params: {league: this.$parent.league}})
    },
    setSeasonDropdown () {
      this.season_dropdown = this.getSeasonDropdownForLeague(this.$route.params.league)
      if (this.$route.query.Season) {
        this.season_dropdown.data.forEach((season) => {
          if (season.id === this.$route.query.Season) {
            this.season_selected = season
          }
        })
      }

      // this happens on league change  - set to first option
      if (this.season_selected === undefined) {
        this.season_selected = this.season_dropdown.data[0]
      }
    },
    setLeverageDropdown () {
      this.leverage_dropdown = this.leverage_dropdown_options
      this.setLeverageSelected()
    },
    getLeverageString () {
      var leverageString = ''
      for (var i = 0; i < this.leverage_selected.length; i++) {
        if (i === 0) {
          leverageString += this.leverage_selected[i].id
        } else {
          leverageString += ',' + this.leverage_selected[i].id
        }
      }
      return leverageString
    },
    setLeverageSelected () {
      this.leverage_selected = []
      if (this.$route.query.Leverage) {
        this.leverage_dropdown.data.forEach((leverageOption) => {
          this.$route.query.Leverage.split(',').forEach((leverageSelected) => {
            if (leverageOption.id === leverageSelected) {
              this.leverage_selected.push(leverageOption)
            }
          })
        })
      }
    },
    checkIfStatsShouldBeLoaded () {
      if (this.$route.query.Season && this.$route.query.Leverage) {
        this.getStats()
      }
    },
    loadData () {
      this.getDropdown([this.setSeasonDropdown, this.setLeverageDropdown, this.checkIfStatsShouldBeLoaded])
    },
    updateData () {
      this.table_data = []

      if (this.$route.query.Season && this.$route.query.Leverage) {
        this.getStats()
      } else {
        this.loadData()
      }
    },
    changeStats () {
      var params = {}
      params[this.$seasonParam] = this.season_selected.id
      params[this.$leverageParam] = this.getLeverageString()

      this.$router.push({name: 'team_leverage_summary', query: params})
    },
    getStats () {
      this.show_error_message = false
      this.table_data = []
      var params = this.$route.query

      if (params.Season && params.Leverage) {
        this.loading = true
        axios.get(process.env.API_BASE_URL + this.api_endpoint + this.$route.params.league, {
          params: params
        })
          .then((response) => {
            if (!response.data.error) {
              this.table_data = response.data.results
              this.table_columns.forEach((column) => {
                if (column.filterable) {
                  column.filterOptions = {enabled: true, placeholder: 'Search'}
                }
              })
            } else {
              this.show_error_message = true
            }
            this.loading = false
          }, (error) => {
            this.show_error_message = true
            this.loading = false
            this.error = error
          })
      }
    }
  }
}
</script>

<style scoped>
@import "https://maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css"

</style>



// WEBPACK FOOTER //
// src/components/TeamLeverageSummary.vue